let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("tdXqH"), load("hTb1M"), load("cdEjw"), load("8yRnn"), load("aZDAn")]).then(() => parcelRequire('72p3J'));